<template>
  <div>
    <div class="container u-p1">
      <h1 class="title has-text-centered is-size-2">{{ $t('general.your-order') }}</h1>
      <h2 class="subtitle has-text-centered" v-if="order.vanityOrderNumber">{{ $t('general.order-number') }}: {{ order.vanityOrderNumber }}</h2>
      <h2 class="subtitle has-text-centered" v-if="!order.vanityOrderNumber">{{ $t('general.from-date') }} {{ new Date(order.orderDate) | dateFormat('DD.MM.YYYY') }}</h2>

      <div class="columns mt-5">
        <div class="column is-12 is-10-desktop is-offset-1-desktop is-8-widescreen is-offset-2-widescreen order-area">
          <div v-if="order && order.paymentType && order.paymentType.status != 40 && order.status < 30" class="notification is-info">
            {{ $t('notices.voucher-available-after-payment') }}
          </div>

          <p class="has-text-centered mb-4" v-if="order.isUnclaimed">
            {{ $t('account.link-to-voucher.sie-moechten-einen') }} <a href="#" v-scroll-to="{el: '#account-options-new', offset: -100}" class="scroll-new-account">{{ $t('account.link-to-voucher.neuen-account-anlegen') }}</a> {{ $t('account.link-to-voucher.oder-die-bestellung-zu-einem') }}
            <a href="#" v-scroll-to="{el: '#account-options-existing', offset: -100}" class="scroll-existing-account">{{ $t('account.link-to-voucher.bestehenden-account-hinzufuegen') }}?</a>
          </p>

          <OrderItem v-for="item in order.orderItems" :key="item.id" :item="item" :paid="order.paymentType.status == 40" :canceled="order.status >= 30 || item.returned" :orderId="order.id" :token="order.token" @voucher-selected="setVoucher" @invoice-download="printInvoice" />

          <section class="section" v-if="order && order.customer && order.paymentType && order.status < 30">
            <div class="columns">
              <div class="column is-5">
                <h3 class="title is-size-6 is-marginless">{{ $t('general.user-data') }}</h3>
                <p>
                  {{ order.customer.sex | gender }}
                  {{ order.customer.firstName }} {{ order.customer.lastName }}
                  <br v-if="order.customer.firstName && order.customer.lastName" />
                  {{ order.customer.email }}
                  <br v-if="order.customer.email" />
                  {{ order.customer.phone }}
                </p>
              </div>
              <div class="column">
                <h3 class="title is-size-6 is-marginless">{{ $t('general.address-data') }}</h3>
                <p>
                  {{ order.customer.address }}
                  <br v-if="order.customer.address" />
                  {{ order.customer.zip }} {{ order.customer.city }}
                  <br v-if="order.customer.zip" />
                  {{ order.customer.country | country }}
                </p>
              </div>
              <div class="column print-payment">
                <h3 class="title is-size-6 is-marginless">{{ $t('general.payment-type') }}</h3>
                <span v-if="order.paymentType.paymentTypeId !== 10">{{ $t(`payment.providers.${order.paymentType.paymentTypeName}`) }}</span>
                <img v-if="order.paymentType.paymentTypeId === 10" v-lazy="'/img/payment/payment_10.svg'" width="150" height="36" :alt="order.paymentType.paymentTypeName" class="u-blend-mode--multiply" loading="lazy" importance="low" />
              </div>
            </div>
          </section>

          <RegisterFromOrderDialog :order="order" id="account-options" />
        </div>
      </div>
    </div>

    <VoucherModal :voucher="currentVoucher" :show.sync="modal" :id="order.id" :token="order.token" @close-request="hideModal" />

  </div>
</template>

<script>
import OrderItem from './OrderItem'
import VoucherModal from './VoucherModal'
import InvoiceApi from '@/api/invoice-api'
import RegisterFromOrderDialog from './RegisterFromOrderDialog'


export default {
  name: 'Order',
  components: {
    OrderItem,
    VoucherModal,
    RegisterFromOrderDialog,
  },
  props: {
    order: Object,
  },
  data() {
    return {
      currentVoucher: {},
      modal: false,
    }
  },
  methods: {
    setVoucher(voucher) {
      this.currentVoucher = voucher
      this.modal = true
    },
    hideModal() {
      this.modal = false
    },
    async printInvoice(orderItem) {
      if (orderItem && orderItem.hasInvoice) {
        try {
           await InvoiceApi.downloadInvoice(this.order.id, this.order.token, orderItem.invoiceNumber)
        }catch{
            this.$store.dispatch('flashMessageDanger', { message:  this.$t('errors.retryable-error')})
        }
       
      }
    },
  },
}
</script>

<style scoped lang="scss">
// .print-payment {
//   background: #f2f2f2;
// }
</style>
